// extracted by mini-css-extract-plugin
module.exports = {"pattern":"PatternedImageOverlay_pattern__3tfiC","hide":"PatternedImageOverlay_hide__30jyI PatternedImageOverlay_pattern__3tfiC"};